import * as React from "react"
import { Outlet } from "react-router-dom"
import { Flex, Box } from "@chakra-ui/react"

import { Nav } from "./Nav"
import { NAV_WIDTH } from "../lib/config"

export const Page = () => {
  return (
    <Flex h="100vh" w="100vw">
      <Nav />
      <Box w={`calc(100% - ${NAV_WIDTH})`} h="100vh">
        <Outlet />
      </Box>
    </Flex>
  )
}
